export default function AccordionDetails() {
  return {
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '.5rem 1.75rem 1rem'
        }
      },
    },
  };
}
